import {keyCodes} from '@pb/kit-util-key-codes';

const separators = [keyCodes.KEY_COMMA, keyCodes.KEY_DECIMAL];
const negatives = [keyCodes.KEY_SUBTRACT, '('];

/**
 * @function convertStringToNumber
 * @description The function is designed to convert text to numbers
 * @param {string} string - Text that we convert to a number
 * @example <caption>1. Example of using a string.</caption>
 * // returns 123
 * convertStringToNumber('123abc');
 * @example <caption>2. Example of using the date.</caption>
 * // returns 11.12
 * convertStringToNumber('11.12.2021');
 * @returns {number | null} converted `number` or `null`
 */
export const convertStringToNumber = (string: string) => {
    let newString = '';
    let isSeparator = false;
    let isNegative = false;

    for (const symbol of string) {
        if (symbol === keyCodes.KEY_SPACE) {
            break;
        } else if (negatives.some(negative => symbol === negative)) {
            if (isNegative) {
                break;
            }

            isNegative = true;
            newString = newString.concat(keyCodes.KEY_SUBTRACT);
        } else if (separators.some(separator => symbol === separator)) {
            if (isSeparator) {
                break;
            }

            isSeparator = true;
            newString = newString.concat(keyCodes.KEY_DECIMAL);
        } else if (Number(symbol) || Number(symbol) === 0) {
            newString = newString.concat(symbol);
        } else {
            break;
        }
    }

    if (!newString.length) {
        return null;
    }

    const result = Number(newString);
    return isNaN(result) ? null : result;
};
